import { Container, Grid, Stack, Typography, alpha, styled, useTheme } from '@mui/material';
import { HEADER } from 'src/layouts/config-layout';
import { useLocales } from 'src/locales';

const StyledLogoContainer = styled(Stack)(({ theme }) => ({
  position: 'relative',

  backgroundImage: 'url(/assets/images/home/bg-gradient.png)',
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'contain',
}));

const StyledImg = styled('img')(({ theme }) => ({
  width: '100%',
  margin: '0 auto',

  zIndex: 2,
}));

function HomeIntroToToken() {
  const theme = useTheme();
  const { t } = useLocales();

  return (
    <Stack
      sx={{
        background: `linear-gradient(to top, ${alpha(
          theme.palette.primary.main,
          0.1
        )} 0%, transparent 20%)`,
        width: '100%',
        height: 'auto',

        [theme.breakpoints.up('md')]: {
          marginTop: `-${HEADER.H_DESKTOP}px`,
          minHeight: `100vh`,
        },
      }}
    >
      <Container maxWidth="lg">
        <Stack sx={{ py: { xs: 5, md: 10 } }}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <Typography variant="h3" color="primary">
                  {t('walkup_lang_182')}
                </Typography>

                <Typography variant="h6" fontWeight="400">
                  {t('walkup_lang_183')}
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledLogoContainer>
                <StyledImg src="./assets/images/home/token-page/token-and-trajectory.png" />
              </StyledLogoContainer>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Stack>
  );
}

export default HomeIntroToToken;
